// extracted by mini-css-extract-plugin
module.exports = {"container":"Documents-module--container--2lvA2","tabs":"Documents-module--tabs--lRhpb","flags":"Documents-module--flags--1eZb7","active":"Documents-module--active--3Pw3K"};